import { useQuery } from "@tanstack/react-query";
import { getCollectionById } from "../../api/apiCollections";
import i18next from "i18next";

/**
 * Hook to fetch a single collection by ID
 * @param {number|string} id - Collection ID
 */
export function useGetCollectionById(id) {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["collection", id, i18next.language],
        queryFn: () => getCollectionById(id),
        enabled: !!id,
        retry: false,
    });

    const collection = data?.data || null;

    return { isLoading, error, collection, refetch };
}
